/**
 * Product page access gate - client-side safety net.
 *
 * The primary gate is server-side (Liquid in layout/theme.liquid). This script
 * exists to catch edge cases where Shopify's full-page cache serves a logged-out
 * response to a logged-in customer, or where AJAX/preview endpoints expose
 * gated product data.
 *
 * Reads window.bmfProductGate (injected by layout/theme.liquid on product pages).
 *
 * Shape of window.bmfProductGate:
 *   {
 *     active: boolean,
 *     requiredTag: string,
 *     customerLoggedIn: boolean,
 *     customerTags: string[],
 *     behavior: 'message' | 'redirect',
 *     loginUrl: string,
 *     deniedRedirectUrl: string
 *   }
 */
(function () {
  var gate = window.bmfProductGate;
  if (!gate || !gate.active) return;

  var requiredTag = String(gate.requiredTag || '').trim().toLowerCase();
  if (!requiredTag) return;

  var tags = Array.isArray(gate.customerTags) ? gate.customerTags : [];
  var hasTag = false;
  for (var i = 0; i < tags.length; i++) {
    if (String(tags[i]).trim().toLowerCase() === requiredTag) {
      hasTag = true;
      break;
    }
  }

  if (gate.customerLoggedIn && hasTag) return;

  // Block access - either redirect or hide content.
  var redirectMode = gate.behavior === 'redirect';
  var target = gate.customerLoggedIn ? gate.deniedRedirectUrl : gate.loginUrl;

  if (redirectMode && target) {
    window.location.replace(target);
    return;
  }

  // Belt-and-suspenders: add a class to html so CSS instantly hides anything
  // the Liquid gate may have missed (e.g. stale cached HTML).
  try {
    document.documentElement.classList.add('bmf-gate-blocked');
  } catch (e) {}
})();
